module.exports = __webpack_public_path__ + "img/register_logo.e9c3e41b.png";